import Rooms from '../components/Report/Rooms'
import Workstation from '../components/Report/Workstation'
import Present from '../components/Report/Present'

let routes = {
    path: '/report',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/report/rooms',
            name: 'Exportação - Salas de Reunião',
            component: Rooms
        },
        {
            path: '/report/workstations',
            name: 'Exportação - Estações de Trabalho',
            component: Workstation
        },
        {
            path: '/report/presents',
            name: 'Exportação - Presenças',
            component: Present
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/report.js